import { useMutation } from '@apollo/client/react'
import VerifyAccount from '../graphql/queries/VerifyAccount'
import { useEffect, useState, useCallback } from 'react'
import { Modal, Stack, Text, Loader } from '@mantine/core'
import { useModalStack } from '../ui/ModalStack'

function redirectHome() {
    window.location.href = window.location.origin + '/'
}

export default function VerifyingModal({ opened, onClose, code, userId, ...props }) {
    const { pushModal } = useModalStack()
    const [verifyMutation] = useMutation(VerifyAccount)
    const [verificationStarted, setVerificationStarted] = useState(false)

    const startVerification = useCallback(async () => {
        try {
            const result = await verifyMutation({ variables: { code, userId } })
            onClose?.()
            if (result?.data?.verifyAccount) {
                pushModal('alert', {
                    title: 'Verification Complete',
                    text: 'Your account has been verified.',
                    okText: 'OK',
                    onClose: redirectHome
                })
            } else {
                pushModal('alert', {
                    title: 'Verification Failed',
                    text: 'The verification code you used is no longer valid.',
                    okText: 'OK',
                    onClose: redirectHome
                })
            }
        } catch (error) {
            console.error('Verification error:', error)
            onClose?.()
            pushModal('alert', {
                title: 'Verification Failed',
                text: 'The verification code you used is no longer valid.',
                okText: 'OK',
                onClose: redirectHome
            })
        }
    }, [code, userId, verifyMutation, onClose, pushModal])

    useEffect(() => {
        if (opened && !verificationStarted && code && userId) {
            setVerificationStarted(true)
            startVerification()
        }
    }, [opened, verificationStarted, code, userId, startVerification])

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Verifying Account"
            centered
            closeOnClickOutside={false}
            closeOnEscape={false}
            withCloseButton={false}
            {...props}
        >
            <Stack gap="md" align="center" py="md">
                <Text size="sm">Verifying your account...</Text>
                <Loader size="md" />
            </Stack>
        </Modal>
    )
}
